import { z } from 'zod';
import { VALID_PATH_REGEX } from '../../../dev-center/components/validations/common.js';
import { createDashboardRouteValidation } from '../../../dev-center/components/validations/dashboard-page.js';
import type { ExtensionDef } from '../generate-schema/types.js';
import { defineField } from '../generate-schema/definitions.js';
import { generateDashboardPage } from './generate.js';

const schema = z.object({
  extensionType: z.literal('DASHBOARD_PAGE'),
  title: z
    .string()
    .describe(
      defineField({ title: 'Page title', description: 'The Page Title' })
    ),
  route: z
    .string()
    .regex(VALID_PATH_REGEX)
    .describe(
      defineField({
        title: 'Page route',
        description: 'Lowercase alphanumeric, hyphens, and slashes',
      })
    ),
});

export const dashboardPage: ExtensionDef<typeof schema> = {
  title: 'Dashboard Page',
  description: 'A Dashboard page',
  group: 'Dashboard',
  documentation:
    'https://dev.wix.com/docs/wix-cli/guides/extensions/dashboard-extensions/dashboard-pages/add-dashboard-page-extensions',
  zodSchema: schema,
  validate: async (projectFolder, data) => {
    const result = createDashboardRouteValidation(projectFolder)(data.route);
    return result.valid ? null : result.reason;
  },
  generate: ({ projectFolder, data }) =>
    generateDashboardPage(projectFolder, data.route, data.title),
};
